import { Injectable } from '@angular/core';
import { DEVICE, DEVICE_ERROR_CODE, NEW_RELIC_EVENT } from '@app/enums/new-relic.enum';
import { NewRelicEventsService } from '@app/services/new-relic-events.service';

/**
 * Servicio centralizado de métricas de dispositivos.
 *
 * Todos los eventos se emiten bajo un único actionSubname `device_metrics`
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceMetricsService {
  constructor(private _newRelicEvents: NewRelicEventsService) {}

  connected(device: DEVICE, statusCode?: number): void {
    this.emit({
      device,
      status: 'connected',
      success: true,
      error: null,
      statusCode: statusCode ?? null,
      durationMs: null,
    });
  }

  disconnected(device: DEVICE, statusCode?: number): void {
    this.emit({
      device,
      status: 'disconnected',
      success: false,
      error: null,
      statusCode: statusCode ?? null,
      durationMs: null,
    });
  }

  error(device: DEVICE, errorCode: DEVICE_ERROR_CODE, errorDetail?: string): void {
    this.emit({
      device,
      status: 'error',
      success: false,
      error: errorCode,
      errorDetail: errorDetail ?? null,
      statusCode: null,
      durationMs: null,
    });
  }

  operationTime(
    device: DEVICE,
    durationMs: number,
    success: boolean,
    errorCode?: DEVICE_ERROR_CODE
  ): void {
    this.emit({
      device,
      status: success ? 'completed' : 'failed',
      success,
      error: errorCode ?? null,
      statusCode: null,
      durationMs,
    });
  }

  private emit(data: Record<string, unknown>): void {
    try {
      this._newRelicEvents.trackEvent(NEW_RELIC_EVENT.DEVICE_METRICS, data);
    } catch (e) {
      console.warn('[DeviceMetrics] Error emitting metric', e);
    }
  }
}
